//Paquetes NPM de GYF. 
import { Engine1Proxy, RestApiProxy, RabbitListener, SagasProxy, ConciergeProxy } from 'com-gyf-webcore-servicehub';
import { LogHelper } from 'com-gyf-webcore-loghelper';

export const GET_DATA_SALDOS_RESUMENES = 'GET_DATA_SALDOS_RESUMENES';
export const RECEIVE_DATA_SALDOS_RESUMENES = 'RECEIVE_DATA_SALDOS_RESUMENES';
export const INITIAL_STATE_SALDOS_RESUMENES = 'INITIAL_STATE_SALDOS_RESUMENES';
export const GET_CUENTA_CORRIENTE_DATA = 'GET_CUENTA_CORRIENTE_DATA';
export const GET_CUOTAS_PENDIENTES_SALDOS_RESUMENES = 'GET_CUOTAS_PENDIENTES_SALDOS_RESUMENES';
export const CLOSE_MODAL_CP_SALDOS_RESUMENES = 'CLOSE_MODAL_CP_SALDOS_RESUMENES';

//Seteo de apiUrl
RestApiProxy.SetApiUrl();

let _dispatch, _vistaCliente = null;

/**
 * Action que obtiene el estado inicial.
 * @param {any} currentScope
 */
export function getScreenData(currentScope, currentAccount) {
    LogHelper.In(getScreenData.name, currentScope);

    return (dispatch, getState) => {
        let state = getState();
        _vistaCliente = JSON.parse(JSON.stringify(state.vistaCliente));

        dispatch({ type: GET_DATA_SALDOS_RESUMENES });

        let params = {
            'CUENTA_TARJETA_ID': currentAccount
        };

        Engine1Proxy.AddDataSourcesRequests(params, 'GET_SALDOS_ENCABEZADO', 'Get', 'Tarjetas', 'CONSULTASOCIOS', 1, 'Product');
        Engine1Proxy.AddDataSourcesRequests(params, 'GET_PROXIMO_RESUMEN', 'Get', 'Tarjetas', 'CONSULTASOCIOS', 1, 'Product');
        Engine1Proxy.AddDataSourcesRequests(params, 'GET_RESUMEN_ANTERIOR', 'Get', 'Tarjetas', 'CONSULTASOCIOS', 1, 'Product');
        Engine1Proxy.AddDataSourcesRequests(params, 'GET_LIMITE_DISPONIBLE_SALDOS_RESUMENES', 'Get', 'Tarjetas', 'ADMINEMPCUETAR', 1, 'Product');
        Engine1Proxy.AddDataSourcesRequests(params, 'GET_DATOS_POPUP_SALDOS', 'Get', 'Tarjetas', 'CONSULTASOCIOS', 1, 'Product');
        Engine1Proxy.Execute((data) => getSaldosResumenesData(data, dispatch), null, null, "CONSULTASOCIOS");
    }
}

/** 
 * Action que obtiene el estado inicial.
 */
export function resetState() {
    LogHelper.In(resetState.name);

    return (dispatch) => {
        dispatch({ type: INITIAL_STATE_SALDOS_RESUMENES });
    }
}

export function getCuentaCorrienteData(cuentaTarjetaId, cuentaTarjetaSaldoId, ...params) {
    LogHelper.In(getCuentaCorrienteData.name);


    return (dispatch) => {

        let ejecutarSP = params ? params[0] : false;

        let parametros = {
            'CUENTA_TARJETA_ID': cuentaTarjetaId,
            'FECHA_CIERRE': cuentaTarjetaSaldoId
        }

        Engine1Proxy.AddDataSourcesRequests(parametros, 'GET_FECHA_CIERRE_CUENTA_CORRIENTE', 'Get', 'Tarjetas', 'CONSULTASOCIOS', 1, 'Product');


        Engine1Proxy.Execute((data) => getCuentaCorrienteDataCallback(data, dispatch, cuentaTarjetaId, ejecutarSP), null, null, "CONSULTASOCIOS");
    }
}


export function getCuotasPendientes(cuentaTarjetaId, fechaCierreMin, fechaCierreMax, fechaHoy) {
    LogHelper.In(getCuotasPendientes.name);

    return (dispatch) => {

        let paramCuentaPeso = {
            'CUENTA_TARJETA_ID': cuentaTarjetaId,
            'FECHA_CIERRE': fechaHoy ? fechaCierreMin : fechaCierreMax,
            'AL_DIA_HOY': fechaHoy,
        }
        Engine1Proxy.AddDataSourcesRequests(paramCuentaPeso, 'GET_DETALLE_CUOTAS_PENDIENTES', 'Get', 'Tarjetas', 'CONSULTASOCIOS', 1, 'Product', true);

        Engine1Proxy.Execute((innerData) => {
            const cuotasPendientes = JSON.parse(innerData.GET_DETALLE_CUOTAS_PENDIENTES).Recordset1.Rows;

            const cuopensPendientesPesos = cuotasPendientes.filter(x => x.MonedaCodigo == 'PESO').map((cuotaPendiente) => {
                return setCuopensPendientes(cuotaPendiente);
            });
            const cuopensPendientesDolares = cuotasPendientes.filter(x => x.MonedaCodigo == 'DOLAR').map((cuotaPendiente) => {
                return setCuopensPendientes(cuotaPendiente);
            });

            let cuotasPendientesPesos = [];

            for (var i = 0; i < cuopensPendientesPesos.length; i++) {
                for (var j = 0; j < cuopensPendientesPesos[i].length; j++) {
                    cuotasPendientesPesos.push(cuopensPendientesPesos[i][j]);
                }
            }

            let cuotasPendientesDolares = [];
            for (var i = 0; i < cuopensPendientesDolares.length; i++) {
                for (var j = 0; j < cuopensPendientesDolares[i].length; j++) {
                    cuotasPendientesDolares.push(cuopensPendientesDolares[i][j]);
                }
            }

            const result = {
                fechasCierresConsumos: JSON.parse(innerData.GET_DETALLE_CUOTAS_PENDIENTES).Recordset0.Rows,
                cuotasPendientesPesos: cuotasPendientesPesos,
                cuotasPendientesDolares: cuotasPendientesDolares,
                totalCuotasPendientesPesos: JSON.parse(innerData.GET_DETALLE_CUOTAS_PENDIENTES).Recordset2.Rows[0],
                totalCuotasPendientesDolares: JSON.parse(innerData.GET_DETALLE_CUOTAS_PENDIENTES).Recordset3.Rows[0],
                tarjetasCreditoId: JSON.parse(innerData.GET_DETALLE_CUOTAS_PENDIENTES).Recordset4.Rows
            }

            dispatch({
                type: GET_CUOTAS_PENDIENTES_SALDOS_RESUMENES, data: result
            });

        }, null, null, "CONSULTASOCIOS");
    }
}

export function toggleTotalCuotasPendientes() {
    LogHelper.In(toggleTotalCuotasPendientes.name);


    return (dispatch) => {
        dispatch({
            type: CLOSE_MODAL_CP_SALDOS_RESUMENES
        });
    }
}

///** ------------------------------     FUNCIONES AUXILIARES    --------------------------------  **/

function setCuopensPendientes(cuotaPendiente) {
    const CuotaCierre = (CuotaCierre) => { return CuotaCierre ? CuotaCierre : "-" }
    return [{
        Cierre: 1,
        CuotaNumero: cuotaPendiente.CuotaCierre1,
        Importe: cuotaPendiente.ImporteCierre1,
        NumeroEstablecimiento: cuotaPendiente.NumeroEstablecimiento,
        NumeroCupon: cuotaPendiente.NumeroCupon,
        RazonSocial: cuotaPendiente.RazonSocial,
        TarjetaCreditoId: cuotaPendiente.TarjetaCreditoId,
        Denominacion: cuotaPendiente.Denominacion,
        TarjetaCreditoNumero: cuotaPendiente.TarjetaCreditoNumero,
        Nombre: cuotaPendiente.Nombre,
        Apellido: cuotaPendiente.Apellido
    }, {
        Cierre: 2,
        CuotaNumero: CuotaCierre(cuotaPendiente.CuotaCierre2),
        Importe: cuotaPendiente.ImporteCierre2,
        NumeroEstablecimiento: cuotaPendiente.NumeroEstablecimiento,
        NumeroCupon: cuotaPendiente.NumeroCupon,
        RazonSocial: cuotaPendiente.RazonSocial,
        TarjetaCreditoId: cuotaPendiente.TarjetaCreditoId,
        Denominacion: cuotaPendiente.Denominacion,
        TarjetaCreditoNumero: cuotaPendiente.TarjetaCreditoNumero,
        Nombre: cuotaPendiente.Nombre,
        Apellido: cuotaPendiente.Apellido
    }, {
        Cierre: 3,
        CuotaNumero: CuotaCierre(cuotaPendiente.CuotaCierre3),
        Importe: cuotaPendiente.ImporteCierre3,
        NumeroEstablecimiento: cuotaPendiente.NumeroEstablecimiento,
        NumeroCupon: cuotaPendiente.NumeroCupon,
        RazonSocial: cuotaPendiente.RazonSocial,
        TarjetaCreditoId: cuotaPendiente.TarjetaCreditoId,
        Denominacion: cuotaPendiente.Denominacion,
        TarjetaCreditoNumero: cuotaPendiente.TarjetaCreditoNumero,
        Nombre: cuotaPendiente.Nombre,
        Apellido: cuotaPendiente.Apellido
    }, {
        Cierre: 4,
        CuotaNumero: CuotaCierre(cuotaPendiente.CuotaCierre4),
        Importe: cuotaPendiente.ImporteCierre4,
        NumeroEstablecimiento: cuotaPendiente.NumeroEstablecimiento,
        NumeroCupon: cuotaPendiente.NumeroCupon,
        RazonSocial: cuotaPendiente.RazonSocial,
        TarjetaCreditoId: cuotaPendiente.TarjetaCreditoId,
        Denominacion: cuotaPendiente.Denominacion,
        TarjetaCreditoNumero: cuotaPendiente.TarjetaCreditoNumero,
        Nombre: cuotaPendiente.Nombre,
        Apellido: cuotaPendiente.Apellido
    }, {
        Cierre: 5,
        CuotaNumero: "-",
        Importe: cuotaPendiente.ImportePosteriores,
        NumeroEstablecimiento: cuotaPendiente.NumeroEstablecimiento,
        NumeroCupon: cuotaPendiente.NumeroCupon,
        RazonSocial: cuotaPendiente.RazonSocial,
        TarjetaCreditoId: cuotaPendiente.TarjetaCreditoId,
        Denominacion: cuotaPendiente.Denominacion,
        TarjetaCreditoNumero: cuotaPendiente.TarjetaCreditoNumero,
        Nombre: cuotaPendiente.Nombre,
        Apellido: cuotaPendiente.Apellido
    }, {
        Cierre: 6,
        CuotaNumero: "-",
        Importe: cuotaPendiente.TotalConsumo,
        NumeroEstablecimiento: cuotaPendiente.NumeroEstablecimiento,
        NumeroCupon: cuotaPendiente.NumeroCupon,
        RazonSocial: cuotaPendiente.RazonSocial,
        TarjetaCreditoId: cuotaPendiente.TarjetaCreditoId,
        Denominacion: cuotaPendiente.Denominacion,
        TarjetaCreditoNumero: cuotaPendiente.TarjetaCreditoNumero,
        Nombre: cuotaPendiente.Nombre,
        Apellido: cuotaPendiente.Apellido
    }];
}

function getSaldosResumenesData(data, dispatch) {
    let GET_SALDOS_ENCABEZADO = JSON.parse(data.GET_SALDOS_ENCABEZADO);
    let GET_LIMITE_DISPONIBLE_SALDOS_RESUMENES = JSON.parse(data.GET_LIMITE_DISPONIBLE_SALDOS_RESUMENES);
    let result = {
        cuenta: JSON.parse(data.GET_SALDOS_ENCABEZADO).Recordset0.Rows[0],
        fechasCierres: JSON.parse(data.GET_SALDOS_ENCABEZADO).Recordset1.Rows[0],
        saldosCierre: JSON.parse(data.GET_SALDOS_ENCABEZADO).Recordset2.Rows[0],
        pagos: JSON.parse(data.GET_SALDOS_ENCABEZADO).Recordset3.Rows[0],
        consumos: JSON.parse(data.GET_SALDOS_ENCABEZADO).Recordset4.Rows[0],
        cuotas: JSON.parse(data.GET_SALDOS_ENCABEZADO).Recordset5.Rows[0],
        ajustes: JSON.parse(data.GET_SALDOS_ENCABEZADO).Recordset6.Rows[0],
        saldosTotales: JSON.parse(data.GET_SALDOS_ENCABEZADO).Recordset7.Rows[0],
        ultimoCierre: JSON.parse(data.GET_SALDOS_ENCABEZADO).Recordset8.Rows[0],
        proximoResumen: JSON.parse(data.GET_PROXIMO_RESUMEN).Recordset0.Rows[0],
        resumenAnterior: JSON.parse(data.GET_RESUMEN_ANTERIOR).Recordset0.Rows[0],
        limiteDisponible: JSON.parse(data.GET_LIMITE_DISPONIBLE_SALDOS_RESUMENES).Recordset0.Rows[0],
        fechasCierreUltimaCartera: JSON.parse(data.GET_DATOS_POPUP_SALDOS).Recordset0.Rows[0],
        pagosRegistradosPesos: JSON.parse(data.GET_DATOS_POPUP_SALDOS).Recordset1.Rows,
        pagosRegistradosDolares: JSON.parse(data.GET_DATOS_POPUP_SALDOS).Recordset2.Rows
    }

    dispatch({ type: RECEIVE_DATA_SALDOS_RESUMENES, data: result });
}

function getCuentaCorrienteDataCallback(data, dispatch, cuentaTarjetaId, ejecutarSP) {

    let fechasCierreCC = JSON.parse(data.GET_FECHA_CIERRE_CUENTA_CORRIENTE).Recordset0.Rows;
    let cantidadFechaCierre = fechasCierreCC.length;
    let fechaCierreMin = null;
    let fechaCierreMax = null;
    let result = { fechasCierreCC };

    if (cantidadFechaCierre > 0) {
        fechaCierreMin = fechasCierreCC[0].FechaCierre;
        fechaCierreMax = fechasCierreCC[cantidadFechaCierre - 1].FechaCierre;
    }

    let paramCuenta = {
        'CUENTA_TARJETA_ID': cuentaTarjetaId,
        'FECHA_CIERRE_MIN': fechaCierreMin,
        'FECHA_CIERRE_MAX': fechaCierreMax
    }

    Engine1Proxy.AddDataSourcesRequests(paramCuenta, 'GET_DETALLE_CUENTA_CORRIENTE', 'Get', 'Tarjetas', 'CONSULTASOCIOS', 1, 'Product');
    Engine1Proxy.AddDataSourcesRequests(paramCuenta, 'GET_CONSUMOS_TARJETAS_CREDITO', 'Get', 'Tarjetas', 'CONSULTASOCIOS', 1, 'Product');

    /*let paramCuenta2 = {
        'CUENTA_TARJETA_ID': cuentaTarjetaId,
        'FECHA_MIN': fechaCierreMin,
        'FECHA_MAX': fechaCierreMax,
        'MONEDA': 'PESO'
    }
    Engine1Proxy.AddDataSourcesRequests(paramCuenta2, 'GET_DETALLE_CUOTAS_PENDIENTES', 'Get', 'Tarjetas', 'CONSULTASOCIOS', 1, 'Product', true, "GET_DETALLE_CUOTAS_PENDIENTES_1");

    let paramCuenta3 = {
        'CUENTA_TARJETA_ID': cuentaTarjetaId,
        'FECHA_MIN': fechaCierreMin,
        'FECHA_MAX': fechaCierreMax,
        'MONEDA': 'DOLAR'
    }
    Engine1Proxy.AddDataSourcesRequests(paramCuenta3, 'GET_DETALLE_CUOTAS_PENDIENTES', 'Get', 'Tarjetas', 'CONSULTASOCIOS', 1, 'Product', true, "GET_DETALLE_CUOTAS_PENDIENTES_2");
    */
    Engine1Proxy.Execute((innerData) => {
        result = {
            ...result,
            /*cuotasPendientesPesos: JSON.parse(innerData.GET_DETALLE_CUOTAS_PENDIENTES_1).Recordset0.Rows,
            totalCuotasPendientesPesos: JSON.parse(innerData.GET_DETALLE_CUOTAS_PENDIENTES_1).Recordset1.Rows[0],
            cuotasPendientesDolares: JSON.parse(innerData.GET_DETALLE_CUOTAS_PENDIENTES_2).Recordset0.Rows,
            totalCuotasPendientesDolares: JSON.parse(innerData.GET_DETALLE_CUOTAS_PENDIENTES_2).Recordset1.Rows[0],
            fechasCierresConsumos: JSON.parse(innerData.GET_DETALLE_CUOTAS_PENDIENTES_1).Recordset2.Rows,
            tarjetasCreditoId: JSON.parse(innerData.GET_DETALLE_CUOTAS_PENDIENTES_1).Recordset3.Rows,*/
            detalleCC: JSON.parse(innerData.GET_DETALLE_CUENTA_CORRIENTE).Recordset0.Rows,
            extensiones: JSON.parse(innerData.GET_CONSUMOS_TARJETAS_CREDITO).Recordset0.Rows,
            consumosTarjetas: JSON.parse(innerData.GET_CONSUMOS_TARJETAS_CREDITO).Recordset1.Rows,
            montoTotales: JSON.parse(innerData.GET_CONSUMOS_TARJETAS_CREDITO).Recordset2.Rows,
            cuotasPendientesTotales: JSON.parse(innerData.GET_CONSUMOS_TARJETAS_CREDITO).Recordset3.Rows
        }

        dispatch({
            type: GET_CUENTA_CORRIENTE_DATA, data: result, fechasCierre: result.fechasCierreCC, ejecutarSP
        });

    }, null, null, "CONSULTASOCIOS");
}


// WEBPACK FOOTER //
// ./Portico/Productos/Tarjetas/App/Screens/SaldosResumenes/actions/SaldosResumenesActions.js